export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7932.c332a4c5.jpg";